import ViewWrapper from 'components/view-wrapper/view-wrapper.vue';
import RouteBuilder from './routeBuilder';
import InnerFrame from 'components/inner-frame/inner-frame';
import OperatingData from 'views/dataPlatform/operateData/Main.vue';
import ProductData from 'views/dataPlatform/productData/Main.vue';
import Comment from 'views/comment/list/Main.vue';
import NHomePage from 'components/nhomepage/nhomepage.vue';

let jiuJingBuilder = new RouteBuilder('jiujing', ViewWrapper, InnerFrame);
let jiuJingRoutes = RouteBuilder.buildBasicInfo(jiuJingBuilder, '/gtyOrder/', NHomePage, true);
let promotionInfo = RouteBuilder.buildPromotionInfo(jiuJingBuilder);
let financeInfo = RouteBuilder.buildFinanceInfo(jiuJingBuilder);
let dataSummaryInfo = RouteBuilder.buildDataSummary(jiuJingBuilder, OperatingData, ProductData);
let commentList = RouteBuilder.buildReviewList(jiuJingBuilder, Comment);
let qaqManage = RouteBuilder.buildQaA(jiuJingBuilder);
import AcademyHome from 'views/academy/HomePage.vue';
let xgxy = RouteBuilder.buildXAXY(jiuJingBuilder, AcademyHome);
let gzzx = RouteBuilder.buildGZZX(jiuJingBuilder);
jiuJingRoutes.push(financeInfo);
jiuJingRoutes.push(dataSummaryInfo);
jiuJingRoutes.push(promotionInfo);
jiuJingRoutes.push(commentList);
jiuJingRoutes.push(qaqManage);
jiuJingRoutes.push(xgxy);
jiuJingRoutes.push(gzzx);

export default jiuJingRoutes;


// WEBPACK FOOTER //
// ./src/router/router.jiujing.js